import { getColorSlug } from "@helpers/getColorSlug";

interface Color {
  color: string[];
  name: string;
  type?: string;
}

export const getPath = (pathname: string, color: Color, isVariant = false): string => {
  // Get current path and search params
  let currentPath: string = pathname || "/";

  // If isVariant is true, add color as query parameter
  if (isVariant) {
    const separator = currentPath.includes('?') ? '&' : '?';
    return `${currentPath}${separator}color=${getColorSlug(color?.name)}`;
  }

  // Remove any existing color slug from path (assuming /colours/[slug])
  const pathParts: string[] = currentPath.split("/");
  const colourIndex: number = pathParts.findIndex((p: string) => p === "colours");
  if (colourIndex !== -1 && pathParts.length > colourIndex + 1) {
    // Replace existing slug
    pathParts[colourIndex + 1] = getColorSlug(color.name);
    currentPath = pathParts.join("/");
  } else {
    currentPath = `${currentPath.replace(/\/$/, "")}/colours/${getColorSlug(color.name)}`;
  }
  return `${currentPath}`;
}

export const generateCurrentPath = (pathName: string): string => {
  const basePath = process.env.NEXT_PUBLIC_FRONTEND_HOST || "";
  let fullPath = basePath.endsWith("/") ? `${basePath}${process.env.NEXT_PUBLIC_BASE_TERM}` : `${basePath}/${process.env.NEXT_PUBLIC_BASE_TERM}`;
  if (!pathName || pathName === "/") {
    return fullPath;
  }

  const url = `${fullPath.replace(/\/$/, '')}/${pathName.replace(/^\//, '')}`;
  return url.replace(/\/+$/, '') + '/';
}